import script from "./registerSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./registerSuccess.vue?vue&type=script&setup=true&lang=js"

import "./registerSuccess.vue?vue&type=style&index=0&id=bab2ffd8&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/DLJY-Web-Test/example/main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bab2ffd8"]])

export default __exports__